import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustStrip from "./components/TrustStrip";
import HotTopics from "./components/HotTopics";
import Boards from "./components/Boards";
import DiscussionFeed from "./components/DiscussionFeed";
import EntranceGuide from "./components/EntranceGuide";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <Hero />
      <TrustStrip />
      <HotTopics />
      <Boards />
      <DiscussionFeed />
      <EntranceGuide />
      <Footer />
    </main>
  );
}